var render, staticRenderFns
import script from "./TerminalAcount.vue?vue&type=script&lang=js"
export * from "./TerminalAcount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('306be373')) {
      api.createRecord('306be373', component.options)
    } else {
      api.reload('306be373', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/rights/fee/terminal_acount/TerminalAcount.vue"
export default component.exports